import React, { useContext, useState } from 'react';
// import { socket } from '../../utils/socket';
import { ProfileImg } from '../../../helper';
import axios from 'axios';
import { AuthContext } from '../../../../context/AuthContextProvider';
import moment from 'moment';
import CommentBox from '../../../News/CommentBox/CommentBox';
import ShareModal from '../../../News/NewsCard/ShareModal';

const url = process.env.REACT_APP_SERVER_URL;

const NewsFeed = ({ data, handleSuccess }) => {
  const [posts, setPosts] = useState([]);
  const [isCommentClicked, setCommentClicked] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const [selectedImages, setSelectedImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleComment = (postId, newComment) => {
    const updatedPosts = posts.map((post) =>
      post.id === postId
        ? { ...post, comments: [...post.comments, { id: post.comments.length + 1, user: 'User', comment: newComment }] }
        : post,
    );
    setPosts(updatedPosts);
  };

  const handleLike = async () => {
    const token = localStorage.getItem('token');
    const postData = {
      userId: currentUser.id,
      postId: data.id,
    };

    axios({
      method: 'post',
      url: `${url}/likes`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: postData,
    }).then((res) => {
      handleSuccess();
    });
  };

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const openImageViewer = (images, index) => {
    setSelectedImages(images);
    setCurrentIndex(index);
    setShowModal(true);
  };

  const closeImageViewer = () => {
    setShowModal(false);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : selectedImages.length - 1));
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev < selectedImages.length - 1 ? prev + 1 : 0));
  };

  return (
    <div className="news-post">
      <div className="user-panel d-flex">
        <ProfileImg
          alt="images"
          className="img-circle bg-cover"
          style={{
            height: '40px',
            width: '40px',
            textAlign: 'center',
            border: '2px solid #e9ecef',
            padding: '1px',
            float: 'left',
          }}
          src={data.profilePicture_Url}
        />

        <div className="d-flex flex-column ml-2">
          <span className="user-text">{data.username}</span>
          <span style={{ fontSize: '10px' }}>{moment(data.createdAt).fromNow()}</span>
        </div>
      </div>
      <p className="post-text">
        {isExpanded ? (
          // Check if postText is a valid URL and make it clickable
          <div dangerouslySetInnerHTML={{ __html: data.content }} />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data.content.slice(0, 100) }} />
        )}
        {data.content.length > 100 && (
          <span className="see-more" onClick={() => toggleExpand(data.id)}>
            {isExpanded ? ' See less' : ' ...See more'}
          </span>
        )}
      </p>

      {data.images.length && data.images.length === 1 ? (
        <div className="post-images single-image">
          <img src={data.images[0]} alt="Post" className="post-img" onClick={() => openImageViewer(data.images, 0)} />
        </div>
      ) : data.images.length && data.images.length === 2 ? (
        <div className=" two-images">
          {data.images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt="Post"
              className="post-img"
              onClick={() => openImageViewer(data.images, index)}
            />
          ))}
        </div>
      ) : (
        <div className="overlay-images">
          {data.images.length > 0 && (
            <div className="main-image">
              <img
                src={data.images[0]}
                alt="Post"
                className="post-img"
                onClick={() => openImageViewer(data.images, 0)}
              />
            </div>
          )}
          <div className="second-images">
            {data.images.length > 2 && (
              <div className="more-overlay" onClick={() => openImageViewer(data.images, 2)}>
                <img src={data.images[2]} alt="Post" className="post-img" />
                <div className="overlay-text">+{data.images.length - 1}</div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="reaction row justify-content-between mt-3">
        <button
          type="button"
          onClick={() => handleLike()}
          className={`btn rounded ${data.isLiked ? 'btn-primary btn-clap py-1 px-3' : 'btn-transparent'} `}
        >
          <img alt="" src="https://img.icons8.com/ios/50/000000/applause.png" width={20} />
          &nbsp;{data.likes} claps
        </button>
        {/* <button
          type="button"
          className="btn rounded btn-transparent"
          data-toggle="collapse"
          data-target="#commentMe"
          aria-expanded="false"
          aria-controls="commentMe"
          onClick={() => setCommentClicked(!isCommentClicked)}
        >
          <i className="far fa-comment-alt" />
          &nbsp;{data.comments} comments
        </button> */}
        {/* <button type="button" className="btn rounded btn-transparent" data-toggle="modal" data-target="#shareModal">
          <i className="fas fa-share" />
          &nbsp;{data.shares} shares
        </button> */}
      </div>
      {isCommentClicked ? (
        <div className="comments">
          <h5 className="comments-title">Comments:</h5>
          <CommentBox postId={data.id} handleComment={handleComment} />
        </div>
      ) : null}
      <ShareModal url={data.shareUrl} />
      {showModal && (
        <div className="image-viewer" onClick={closeImageViewer}>
          <span className="close-btn">&times;</span>
          <button
            className="prev-btn"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            &#10094;
          </button>
          <img
            src={selectedImages[currentIndex]}
            alt="Post"
            className="full-image"
            onClick={(e) => e.stopPropagation()} // Prevent closing on image click
          />
          <button
            className="next-btn"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            &#10095;
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsFeed;
